<div class="page-container">
  <app-toolbar [title]="'COMMON.UPLOAD_CALL' | translate"></app-toolbar>
  <div class="page">
    @if (data !== null) {
      <form class="form-container" #dataForm="ngForm" (ngSubmit)="uploadCall()">
        <p translate="UPLOAD_CALL.DESCRIPTION"></p>
        @if (chosenFile === null) {
          <input
            #fileInput
            hidden="true"
            type="file"
            name="file"
            onclick="this.value = null"
            (change)="fileInputChanged($event)"
            [accept]="acceptedFileTypesString"
          />
          <button mat-flat-button color="primary" (click)="fileInput.click()" translate="COMMON.CHOOSE_A_FILE" type="button"></button>
        } @else {
          <div class="file-name-container">
            @if (!uploading) {
              <button
                mat-icon-button
                color="warn"
                (click)="data.uploadKey = null; data.fileExtension = null; chosenFile = null"
                [matTooltip]="'COMMON.CHOOSE_ANOTHER_FILE' | translate"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
            {{ chosenFile.name }} ({{ chosenFile.size | filesize }})
          </div>
          @if (uploading) {
            <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
          } @else if (data.uploadKey === null) {
            <button mat-flat-button color="primary" (click)="upload()" translate="COMMON.UPLOAD" type="button"></button>
          }
        }
        <br />
        @if (data.uploadKey !== null) {
          <mat-form-field subscriptSizing="dynamic">
            <mat-label translate="COMMON.NAME"></mat-label>
            <input matInput required name="name" [(ngModel)]="data.name" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label translate="COMMON.LOCATION"></mat-label>
            <input matInput name="location" [(ngModel)]="data.location" />
          </mat-form-field>
          <app-datetime-picker [(ngModel)]="data.date" name="date"></app-datetime-picker>

          @if (organizationUsersWithoutCurrentUser$ | async; as result) {
            @if (result.isSuccess) {
              <app-selection
                labelKey="COMMON.CALL_OWNERS"
                idField="id"
                nameField="fullName"
                [options]="addFullNameToUserList(result.data!)"
                (selectionChange)="onUserSelectionChange($event)"
              ></app-selection>
              <div class="disclaimer-box">
                <mat-icon class="disclaimer-icon">info</mat-icon>
                {{ 'UPLOAD_CALL.DISCLAIMER' | translate }}
              </div>
            }
          }

          <div class="documents">
            <div class="document board-pack">
              <h4 translate="COMMON.BOARD_PACK_UPLOAD"></h4>
              <app-file-upload
                type="board-pack"
                [acceptedFileTypes]="boardPackExtensions"
                [maxSize]="boardPackMaxSize"
                (fileChange)="data.boardPackUploadInfo = $event"
              ></app-file-upload>
            </div>

            <div class="document agenda">
              <h4 translate="COMMON.AGENDA_UPLOAD"></h4>
              @if (currentUser$ | async; as user) {
                <div class="document agenda">
                  <app-file-upload
                    type="agenda"
                    [acceptedFileTypes]="agendaExtensions"
                    [maxSize]="agendaMaxSize"
                    (fileChange)="data.agendaUploadInfo = $event"
                  ></app-file-upload>
                </div>
              }
            </div>
          </div>

          <h3 translate="MINUTES_STYLING.TITLE"></h3>
          <app-minutes-styling [data]="data" (update)="updateMinutesStyling($event)"></app-minutes-styling>
          @if (uploadCallMutation.result$ | async; as result) {
            @if (result.isPending) {
              <app-spinner></app-spinner>
            } @else if (result.isError) {
              @if (result.error.message === 'FILE_TOO_BIG') {
                <p translate="UPLOAD_CALL.FAILURE.FILE_TOO_BIG"></p>
              } @else {
                <p translate="UPLOAD_CALL.FAILURE.UNKNOWN_FAILURE"></p>
              }
            } @else {
              <button mat-flat-button color="primary" type="submit" name="submit" [disabled]="!dataForm.valid" translate="COMMON.UPLOAD"></button>
            }
          }
        }
      </form>
    }
  </div>
</div>
